
export default {
  props: {
    categories: {
      type: Array,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      default: '',
    },

    selectedCategory: {
      type: [Object, null],
      default: null,
    },
  },

  computed: {
    dropdownItems() {
      return this.categories.reduce((prev, next) => {
        prev.push({
          text: next.path,
          value: next,
          id: next.categoryId,
        })

        if (next.subCategories) {
          next.subCategories.forEach((subCategory) => {
            prev.push({
              text: `-- ${this.trimmedChildTitleOfParent(subCategory, next)}`,
              value: subCategory,
              id: subCategory.categoryId,
            })
          })
        }

        return prev
      }, [])
    },
  },

  methods: {
    onSelect(id) {
      const option = this.dropdownItems.find((item) => item.id === id)
      this.$emit('select-category', option.value)
    },

    trimmedChildTitleOfParent(child, parent) {
      return child.path.replace(`${parent.path}, `, '').trim()
    },
  },
}
